import { useRef, useState } from 'react';
import { StyleSheet, TextInput, View } from 'react-native';

export default function OtpInput({ onOtpFilled }: { onOtpFilled: (otp: string) => void }) {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef<(TextInput | null)[]>([]);

const handleChange = (text: string, index: number) => {
  const newOtp = [...otp];
  newOtp[index] = text;
  setOtp(newOtp);

  if (text && index < otp.length - 1) {
    inputRefs.current[index + 1]?.focus();
  }

  onOtpFilled(newOtp.join(""));
};


const handleKeyPress = (e: any, index: number) => {
  if (e.nativeEvent.key === "Backspace" && otp[index] === "" && index > 0) {
    const newOtp = [...otp];
    newOtp[index - 1] = ""; 
    setOtp(newOtp);

    inputRefs.current[index - 1]?.focus();
  }
};



  return (
    <View style={styles.container}>
      {otp.map((digit, index) => (
        <TextInput
          key={index}
          ref={(ref) => {
            inputRefs.current[index] = ref; 
          }}
          value={digit}
          onChangeText={(text) => handleChange(text, index)}
          keyboardType="number-pad"
          maxLength={1}
          style={styles.input}
              onKeyPress={(e) => handleKeyPress(e, index)}
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "center",
    marginVertical: 20,
    width: "100%",
  },
  input: {
    width: 50,
    height: 50,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 8,
    textAlign: "center",
    fontSize: 20,
    marginHorizontal: 10,
    backgroundColor: "#fff",
  },
});
